export default {"src":"/_next/static/media/error.55db2e26.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};